// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper___g8Nq","truncatedText":"styles_truncatedText__pmp7Y","fullText":"styles_fullText__0JbPy","textContainer":"styles_textContainer__6b3hR"};